import React from "react";
import styles from "./Accordion.scss";

const downArrow = require("../../assets/ic_dropdown.svg");
const snaggleTooth = require("../../assets/ic_rectangle_dropdown_white.svg");

const Accordion = ({ title, open, openToggle, children }) => {
  return (
    <div className={styles.accordian}>
      <button
        className={styles.openButton}
        onClick={openToggle}
        aria-label="Open"
      />
      <h4>{title}</h4>
      <img
        className={styles.dropDownArrow}
        src={downArrow}
        style={{ transform: `rotateZ(${open ? -180 : 0}deg)` }}
        alt="Open Arrow"
      />
      {open ? (
        <div className={styles.childWrapper}>
          <img className={styles.snaggleTooth} src={snaggleTooth} alt="" />
          {children}
        </div>
      ) : (
        <div />
      )}
    </div>
  );
};

export default Accordion;
